import React from 'react'

export const AppStabilityPaneContext = React.createContext<{
  id?: string
}>({})
